

const LiveService = {
	getLives: () => Promise.resolve([]),
	getAllLives: () => Promise.resolve([]),
	postLiveReserve: () => Promise.resolve({}),
	cancelLiveReserve: () => Promise.resolve({})
}

export default LiveService
